import { readTextListPrefix, type CanvasTextListPrefix } from '@hector/shared-types';
import { lireLesMarques } from './marquesDeTexte';

/**
 * Décrit le préfixe réellement saisi, hors du texte éditable et de ses coordonnées.
 * La projection échappe les tirets et encode les tabulations ; une liste Word
 * native porte son propre libellé et ne doit jamais être confondue avec ce texte.
 */
export function textListPrefixFromProjection(block: { nodeType: string; fullText: string }): CanvasTextListPrefix | undefined {
  if (block.nodeType !== 'paragraph' || block.fullText.includes('data-superdoc-list-label')) return undefined;
  return readTextListPrefix(lireLesMarques(block.fullText).texte);
}
